<template>
  <div
    ref="flashcard-view-container"
    class="question-of-the-day-view-container"
  >
    <page-header :breadcrumbs="breadcrumbs">
    </page-header>
    <flashcard
      :answered="answered"
      :answer-ids="answerIds"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :show-rationale="true"
      :terminology="isTerminology"
      @set-answer-ids="setAnswerIds"
      @set-raw-answer-data="setRawAnswerData"
    />
    <flashcard-footer
      :answered="answered"
      :answer-ids="answerIds"
      :correct="correct"
      :flashcard="currentFlashcard"
      :raw-answer-data="rawAnswerData"
      :show-bookmark="true"
      :show-flashcard-statuses="true"
      @answer="onAnswered"
      @tag="tagWithModal"
    />
  </div>
</template>

<script>
import Flashcard from '@/components/flashcards/flashcard.vue';
import FlashcardFooter from '@/components/flashcards/footer.vue';
import PageHeader from '@/components/singletons/pageHeader.vue';

import FlashcardViewMixin from '@/mixins/flashcardViews';
import GlobalMixin from '@/mixins/global';
import QuestionOfTheDayMixin from '@/mixins/qotd';
import QuestionsUIV2Mixin from '@/mixins/questions-ui-v2';

import { isSameDay } from 'date-fns';

export default {
  name: 'QuestionOfTheDayView',
  components: {
    Flashcard, FlashcardFooter, PageHeader,
  },
  mixins: [FlashcardViewMixin, GlobalMixin, QuestionOfTheDayMixin, QuestionsUIV2Mixin],
  computed: {
    breadcrumbs() {
      return [{ name: 'Question of the Day' }];
    },
    currentFlashcardCategory() {
      return this.$store.getters['categories/categories'][this.$route.params.categoryId];
    },
    nextFlashcardRoute() {
      return { name: 'home' };
    },
    hasAllParams() {
      return this.$route.params.flashcardId && this.$route.params.categoryId;
    },
  },
  created() {
    // we need to grab the flashcard states
    // we need to make sure we have fetched the flashcard
    this.$store.dispatch('flashcardStates/fetchStates', ['flashcards']);

    if (this.hasAllParams) {
      this.sessionPromise = this.$store.dispatch('flashcards/fetchFlashcards', { ids: [this.$route.params.flashcardId], rateLimited: true });
    } else {
      this.sessionPromise = this.$store.dispatch('flashcards/fetchQuestionOfTheDay');
    }
  },
  mounted() {
    this.sessionPromise.then((data) => {
      let flashcard, categoryId;

      if (this.hasAllParams) {
        flashcard = data[0];
        categoryId = this.$route.params.categoryId;
      } else {
        flashcard = data.flashcard;
        categoryId = data.categoryId;
      }

      if (flashcard) {
        this.$router.replace({
          name: this.getCorrectRouteName(flashcard),
          params: { categoryId, flashcardId: flashcard.id },
          query: this.currentQuery,
        });
      }
    });
  },
  methods: {
    onAnswered() {
      const correct = this.evaluateAnswer(this.currentFlashcard, this.answerIds, this.rawAnswerData);
      this.correct = correct;
      this.answered = true;
      const isQOTD = this.$route.path.includes('/qotd');
      this.$analytics.events.answeredFlashcard(this.$store, this.currentFlashcardCategory, this.currentFlashcard, this.answerIds, this.rawAnswerData, correct, isQOTD, this.dashboard?.name);
    },
    restoreStateFromFlashcardState(flashcard) {
      if (!flashcard) {
        return;
      }

      const stateId = `${flashcard?.id}-category-${this.$route.params.categoryId}`;
      const state = this.$store.getters['flashcardStates/flashcardStates'][stateId];
      if (state) {
        const wasAnsweredToday = isSameDay(state?.mobileCreatedAt, new Date());
        if(wasAnsweredToday) {
          this.answered = true;
          this.setAnswerIds(state.answerIds);
          this.setRawAnswerData(state.rawAnswerData);
        }
      }

      this.correct = this.evaluateAnswer(flashcard, this.answerIds, this.rawAnswerData);
    },
  },
};
</script>

<style lang='scss' scoped>
  .flashcard-view-container {
    @include flashcard-view;
  }
</style>
